import {sendEvent} from '@github-ui/hydro-analytics'
import type {IssueFieldType} from './issue-field'

const EVENT_NAMESPACE = 'issue_fields_usage'

export type IssueFieldsUsageEvent = {
  page: 'org#settings' | 'issue#show' | 'issue#new' | 'memex#show'
  action: 'create' | 'update' | 'delete'
  fieldId: string
  fieldType: IssueFieldType | 'unknown' // 'unknown' is used for fields that are not recognized
  status: 'success' | 'error' | 'cancelled'
  duration?: number

  singleSelectOptionsCount?: number
  interactionDuration?: number
  errorDetails?: string
}

export function reportIssueFieldsUsage(event: IssueFieldsUsageEvent, enabled: boolean) {
  if (!enabled) return
  // change keys from camelCase to snake_case
  const formattedEvent: Record<string, string | number> = {}
  for (const [key, value] of Object.entries(event)) {
    if (value !== undefined) {
      // Only include defined values
      const snakeCaseKey = key.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase()
      formattedEvent[snakeCaseKey] = value
    }
  }

  sendEvent(EVENT_NAMESPACE, {
    ...formattedEvent,
  })
}
